import { useCallback } from 'react';

import { useReduxState } from '@/app/shared/context/ReduxStoreContext';

import { listingLayoutViewModeSelector } from '@/packages/redux-state/store/slices/listingLayout/selectors/dumb';

export const useViewModeChangedToList = (): (() => boolean) => {
  const reduxState = useReduxState();

  return useCallback(() => listingLayoutViewModeSelector(reduxState.getState()) === 'list', [reduxState]);
};
